var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vab-ad"},[_c('vab-breadcrumb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }